import PropTypes from 'react-proptypes';
import {RateDeviationType} from "../../src/enumeration/rateDeviationType";
import {EnergyLabel} from "../../src/enumeration/energyLabel";

export default {
  app: 'renteoverzicht',
  syncing: false,
  broken: false,
  settings: null,
  framed: false,
  input: {
    mortgage_type: 6,
    selected_provider: null,
    rate_deviations: [RateDeviationType.CHECKING_ACCOUNT, RateDeviationType.QUOTATION_INTEREST_DISCOUNT],
    energy_label: EnergyLabel.ENERGY_LABEL_A,
    prefer_collaboration: false,
    prefer_auto_risk_class_reduction: false,
    nhg: true,
    ltv: 100,
    available_for: 'A',
    frt: [0, 120, 240, 300, 360],
    sorted_frt: 120,
    showAllResults: false,
    activeTop: null,
    label_id: null,
    product_id: null,
    selectedLabel: 'S0',
    switchMobileCustomLtv: false,
    switchCustomLtv: false,
    mortgageValue: null,
    houseValue: null,
    customLtv: null,
    mobileCustomLtv: null,
  },
  output: {
    errors: {},
  },
};

// No objects or Arrays included in whitelist at the moment
// Objects and Arrays cannot be send in their current format in the url
// If they need to be send then get the primitive value that is needed or stringify first
const whiteListUrlParams = [
  'selected_provider',
  'prefer_collaboration',
  'prefer_auto_risk_class_reduction',
  'nhg',
  'ltv',
  'sorted_frt',
  'showAllResults',
  'activeTop',
  'label_id',
  'label_name',
  'product_id',
  'switchMobileCustomLtv',
  'switchCustomLtv',
  'mortgageValue',
  'houseValue',
  'customLtv',
  'mobileCustomLtv',
  'mortgageValue',
  'mortgageTypeValue',
  'providerLabel',
  'mortgage_provider_id',
  'mortgage_provider_name',
  'nhg',
  'sorted_frt',
  'interest_rate',
];

const { string, bool, shape } = PropTypes;

const shapeSettings = shape({
  leadButtonUrl: string,
  leadButtonText: string,
  showLeadButton: bool,
  leadFormHeader: string,
  leadFormText: string,
});

const shapeOutput = shape({
  errors: shape({}),
});

const shapeInput = shape({
  mortgage_type: PropTypes.number,
  selected_provider: PropTypes.string,
  prefer_collaboration: PropTypes.bool,
  prefer_auto_risk_class_reduction: PropTypes.bool,
  nhg: PropTypes.bool,
  ltv: PropTypes.number,
  available_for: PropTypes.string,
  frt: PropTypes.arrayOf(PropTypes.number),
  sorted_frt: PropTypes.number,
  showAllResults: PropTypes.bool,
  activeTop: PropTypes.any,
  label_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  product_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  selectedLabel: PropTypes.string,
  switchMobileCustomLtv: PropTypes.bool,
  switchCustomLtv: PropTypes.bool,
  mortgageValue: PropTypes.number,
  houseValue: PropTypes.number,
  customLtv: PropTypes.number,
  mobileCustomLtv: PropTypes.number,
});

export { shapeOutput, shapeInput, shapeSettings, whiteListUrlParams };
